import React from 'react';
import ReactDOM from 'react-dom/client';
import queryString from 'query-string';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import {QueryClientProvider} from '@tanstack/react-query';
import TranslationsProvider from './store/contexts/TranslationsProvider';
import { SESSION_STORAGE_KEY, PARAMETERS_STORAGE_KEY, queryClient } from './utils/config';
import { authentication } from './store/actions/auth-actions';

const requestParameters = queryString.parse(window.location.search);
const { mtoken } = requestParameters;
if(mtoken){
  localStorage.removeItem(SESSION_STORAGE_KEY);
  localStorage.removeItem(PARAMETERS_STORAGE_KEY);
  const credential = {
    masterToken: mtoken,
    variant: 'connect'
  }; 
  store.dispatch(authentication(credential));
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <TranslationsProvider>
          <App/>
        </TranslationsProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
